import React, { useState, useEffect } from 'react';

const ReportsReviewDialog = ({
    open,
    onClose,
    title = "Reports Review",
    message = "If you have any observations or comments on the generated reports, kindly upload the reviewed version and proceed with the outlined steps to initiate the rectification process",
    buttonText = "Continue",
    onButtonClick,
    onSkip
}) => {
    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else {
            onClose();
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

   const handleSkipClick = () => {
        if (onSkip) {
            onSkip(); 
        }
    };
    if (!open) return null;

    return (
        <div
            className="dialog-backdrop"
            onClick={handleBackdropClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
        >
            <div
                className="dialog-paper"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '16px',
                    minWidth: '400px',
                    maxWidth: '600px',
                    width: 'auto',
                    textAlign: 'center',
                    boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
                    maxHeight: '90vh',
                    overflow: 'auto'
                }}
            >
                <div
                    className="dialog-title"
                    style={{
                        fontFamily: 'DM Sans, sans-serif',
                        fontWeight: 700,
                        fontSize: '24px',
                        color: '#02462E',
                        paddingBottom: '8px',
                        margin: 0
                    }}
                >
                    {title}
                </div>

                <div
                    className="dialog-content"
                    style={{
                        padding: '16px 0',
                        width: '100%', // Ensure the content takes the full width of the container
                    }}
                >
                    <div
                        style={{
                            fontFamily: 'DM Sans, sans-serif',
                            fontWeight: 400,
                            fontSize: '16px',
                            color: '#A3AED0',
                            marginBottom: '16px',
                            lineHeight: 1.5,
                            wordBreak: 'break-word', // Break long words to wrap text
                            whiteSpace: 'normal', // Allow text to wrap naturally
                        }}
                    >
                        {message}
                    </div>
                </div>

                <div
                    className="dialog-actions"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '16px',
                        gap: '16px'
                    }}
                >

                    <button
                        onClick={handleButtonClick}
                        style={{
                            background: '#02462E',
                            width: '120px',
                            height: '40px',
                            borderRadius: '8px',
                            color: '#fff',
                            textTransform: 'none',
                            fontFamily: 'DM Sans, sans-serif',
                            fontWeight: 600,
                            fontSize: '14px',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#02462E';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#02462E';
                        }}
                    >
                        {buttonText}
                    </button>
                    <button
                        onClick={handleSkipClick}
                        style={{
                            background: '#02462E',
                            width: '120px',
                            height: '40px',
                            borderRadius: '8px',
                            color: '#fff',
                            textTransform: 'none',
                            fontFamily: 'DM Sans, sans-serif',
                            fontWeight: 600,
                            fontSize: '14px',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#02462E';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#02462E';
                        }}
                    >
                        Skip
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportsReviewDialog;